import { render, staticRenderFns } from "./PrintMenuPhotoPlus.vue?vue&type=template&id=19beaea6&scoped=true&"
import script from "./PrintMenuPhotoPlus.vue?vue&type=script&lang=js&"
export * from "./PrintMenuPhotoPlus.vue?vue&type=script&lang=js&"
import style0 from "./PrintMenuPhotoPlus.vue?vue&type=style&index=0&id=19beaea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19beaea6",
  null
  
)

export default component.exports